import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import axios from 'axios';

import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";

import { CloseOrCancelIcon } from "../../../assets/CloseOrCancel";

import  EditButton from "../../../assets/EditButton.svg";
import  Close from "../../../assets/CloseButton.svg";
import  Link from "../../../assets/link.svg";

import "./sensorInfoModal.css";

import Skeleton from "../../../components/skeleton/Skeleton";

import { getUsLocaleString, getSyncLabel, dateParser } from "../../../utils/TimeUtils";
import { getSyncIcon, getSyncStatusID } from "../../../utils/Icons";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

type SensorDetails = {
    participantID: string; // Example: 'LAS001NNN'
    healthScore: number; // Value from 1 to 10
    sensorID: string; // 12 digit Hexadecimal Format
    sensorBattery: number; // Value from 0 - 100
    lastSyncTime: string; // Time data type
    firstSyncTime: string; // Time data type
    provisionTime: string; // Time data type
    organizationName: string; // Example: 'org-A'
    studyName: string; // Example: 'study-A'
    pinnedStatus: boolean;
    syncStatus: string;
};

interface Participant {
    euid: string | null;
    assignment_time: string | null;
    detach_time: string | null;
    study_participant_id: string | null;
}
  
interface DeviceData {
    device_uuid: string;
    firmware_version: string | null;
    current_euid: string | null;
    participants: Participant[] | null;
}

export type SensorInfoModalProps = {
    data: SensorDetails | null;
    onCloseClicked: () => void;
};

const SensorInfoModal: React.FC<SensorInfoModalProps> = ({ data, onCloseClicked }) => {

    const [additionalData, setadditionalData] = useState<DeviceData | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const response = await axios.get(`${BASE_URL}/getOtherSensorDetails/?device_uuid=${data?.sensorID}`);
            
            if(response.data['statusCode'] === 200){

                // console.log("Fetched Data", JSON.parse(response.data['body']))
                setadditionalData(JSON.parse(response.data['body']))

                // console.log("Fetched Data", additionalData);

            }else {
                throw new Error('Failed to fetch data');
            }

          } catch (err) {
            setError('Failed to fetch data');
          } finally {
            setLoading(false);
          }
        };
    
        fetchData();
    }, [data]);

    return (
        <>  
            <div className="modal-header">
                <div className="main-heading">
                    <span className="title title-large">Sensor Details</span>
                </div>
                <div className="row">
                    
                    <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Icon,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Outlined,
                            label: "",
                            icon: EditButton,
                        }}
                        onClick={() => {
                            console.log("Info icon clicked");
                        }}
                    />
                    <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Icon,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Clean,
                            label: "",
                            icon:Close,
                            className: "close-button",
                        }}
                        onClick={onCloseClicked}
                    />
                    
            
                </div>
        
            </div>
            <div className="sensorinfo-modal-detail">
                

                <div className="info-row">
                    <div className="info-column">
                        <div className="label label-small label-grey">Sensor ID</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">{data?.sensorID}</div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">Sensor Battery</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">
                            <span ></span>
                        </div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">Firmware Version</div>
                        <div className="info-padding"></div>
                        {loading ? <Skeleton></Skeleton> : <div className="title title-small">{additionalData?.firmware_version}</div>}
                    </div>
                </div>
                <div className="seperator"></div>
                
                <div className="info-row title-no-margin">
                    <span className="title title-small">Timestamps</span>
                </div>

                
                <div className="info-row">
                    <div className="info-column">
                        <div className="label label-small label-grey">Last Sync Time</div>
                        <div className="info-padding"></div>
                        <div className="title title-small icon-plus-label">
                            <img alt="icon" className="icon-padding" src={getSyncIcon(getSyncStatusID(dateParser(data?.lastSyncTime ? String(data.lastSyncTime) : null)))}></img>
                            <span>
                                {getSyncLabel(
                                    dateParser(
                                    data?.lastSyncTime ? String(data.lastSyncTime) : null
                                    )
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">First Sync Time</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">{getSyncLabel(
                                    dateParser(
                                        data?.firstSyncTime ? String(data?.firstSyncTime) : null
                                    )
                                )}</div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">Provision Time</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">{getSyncLabel(
                                    dateParser(
                                        data?.provisionTime ? String(data?.provisionTime) : null
                                    )
                                )}</div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">Attachment</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">{getSyncLabel(
                                    dateParser(
                                        data?.provisionTime ? String(data?.provisionTime) : null
                                    )
                                )}</div>
                    </div>
                </div>
                
                
                <div className="seperator"></div>

                <div className="info-row title-no-margin">
                    <span className="title title-small">Assigned Participant</span>
                </div>

                <div className="info-row">
                    <div className="info-column">
                        <div className="label label-small label-grey">Participant ID</div>
                        <div className="info-padding"></div>
                        <div className="title title-small">{data?.participantID}</div>
                    </div>
                    <div className="info-column">
                        <div className="label label-small label-grey">EUID</div>
                        <div className="info-padding"></div>
                        {loading ? <Skeleton></Skeleton> : <div className="title title-small">{additionalData?.current_euid}</div>}
                    </div>
                </div>

                <div className="seperator"></div>

                <div className="info-row">
                    <span className="title title-small">History of Attachments</span>
                </div>
                {loading 
                ? <Skeleton></Skeleton> 
                : additionalData?.participants?.map((x, i) => ( 

                    <div className="attached-participant-history-box">
                        <div className="icon-box">
                            <MasterButton
                                options={{
                                    layoutType: ButtonLayoutType.Icon,
                                    size: ButtonSize.Medium,
                                    variation: ButtonVariation.Clean,
                                    label: "",
                                    icon: Link,
                                }}
                                onClick={() => {
                                }}
                            />
                        </div>
                        <div className="text-content">
                            <div className="title title-small">Attached to Participant {x.study_participant_id}</div>
                            <div className="title label-small">{getSyncLabel(dateParser(x?.assignment_time ? String(x?.assignment_time) : null))} - {getSyncLabel(dateParser(x?.detach_time ? String(x?.detach_time) : null))}</div>
                        </div>
                    </div>
                    
                ))}

                <div className="padding"></div>
            </div>
        </>
    );
};

export default SensorInfoModal;


